import { render } from "./NovedadesFiltro.vue?vue&type=template&id=007bc74d&scoped=true"
import script from "./NovedadesFiltro.vue?vue&type=script&lang=js"
export * from "./NovedadesFiltro.vue?vue&type=script&lang=js"

import "./NovedadesFiltro.vue?vue&type=style&index=0&id=007bc74d&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-007bc74d"]])

export default __exports__